import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as ExportBatchesActions from '../actions/export-batches.actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwExportBatchesApiService } from 'app/services/export-batches-api.service';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class ExportBatchesEffects {
  createExportBatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExportBatchesActions.createExportBatch),
      switchMap(({ exportBatch }) =>
        this.exportBatchesApiService.create(exportBatch).pipe(
          switchMap((newExportBatch) => [
            ExportBatchesActions.createExportBatchSuccess(newExportBatch),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_export_batch_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(ExportBatchesActions.createExportBatchFailed({ error }))
          )
        )
      )
    )
  );

  updateExportBatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExportBatchesActions.updateExportBatch),
      switchMap(({ exportBatch }) =>
        this.exportBatchesApiService.update(exportBatch).pipe(
          switchMap((response) => [
            ExportBatchesActions.updateExportBatchSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_export_batch_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(ExportBatchesActions.updateExportBatchFailed({ error }))
          )
        )
      )
    )
  );

  deleteExportBatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExportBatchesActions.deleteExportBatch),
      switchMap(({ exportBatch }) =>
        this.exportBatchesApiService.delete(exportBatch).pipe(
          switchMap(() => [
            ExportBatchesActions.deleteExportBatchSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_export_batch_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(ExportBatchesActions.deleteExportBatchFailed({ error }))
          )
        )
      )
    )
  );

  deleteExportBatchesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExportBatchesActions.deleteExportBatchesList),
      switchMap(({ exportBatches }) =>
        this.exportBatchesApiService.delete(exportBatches).pipe(
          switchMap(() => [
            ExportBatchesActions.deleteExportBatchesListSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_export_batches_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(ExportBatchesActions.deleteExportBatchesListFailed({ error }))
          )
        )
      )
    )
  );

  exportExportBatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExportBatchesActions.exportExportBatch),
      switchMap(({ exportBatch }) =>
        this.exportBatchesApiService.export(exportBatch).pipe(
          switchMap(() => [
            ExportBatchesActions.exportExportBatchSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.export_export_batch_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(ExportBatchesActions.exportExportBatchFailed({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private exportBatchesApiService: MwExportBatchesApiService
  ) {}
}
